import {Injectable} from '@angular/core';
import {AbstractUrsService} from '../../../shared/services/index';
import {Observable} from 'rxjs/Observable';
import {Response} from '@angular/http';

/**
 * Authentication service
 * @class
 * @extends AbstractUrsService
 */
@Injectable()
export class UserAuthenticationService extends AbstractUrsService {
  protected prefix: string = 'user/profile';

  /**
   * Calls the login form to get the session cookie
   * @returns {Observable<Response>}
   */
  login(): Observable<Response> {
    return this.callPostEndpoint('login', true);
  }

  /**
   * Gets the user data from Prism
   * @returns {Observable<any>}
   */
  getUser(): Observable<any> {
    this.dismissLoading();
    return this.callGetEndpoint('mobile/content/get-user', false, true);
  }

  /**
   * Authenticates the user
   * @param {string} username users name
   * @param {string} password users password
   * @returns {Observable<Response>}
   */
  authenticateUser(username: string = null, password: string = null): Observable<Response> {
    const formData = {
      'form[_password]': password,
      'form[_username]': username,
    };

    this.setParams(formData);
    this.setLoadingMessage('Logging in');
    return this.callPostEndpoint("check-login");

  }

  /**
   * Logs the user out
   * @returns {Observable<Response>}
   */
  logout(): Observable<Response> {
    this.setLoadingMessage('Logging you out');
    return this.callGetEndpoint('logout');
  }

  /**
   * Checks to see if the user is logged in
   * @returns {Observable<any>}
   */
  isUserLoggedIn(): Observable<any> {
    this.setSkipAccessDeniedRedirect(true);
    return this.callGetEndpoint('mobile/user/isloggedin', true, true);
  }
}



// WEBPACK FOOTER //
// ./src/app/user/login/services/user-authentication.service.ts